import React from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import CLocalizedTextString from '../../components/CLocalizedTextString';
import CSortDropdown from '../../components/CSortDropdown';
import {factSheetSections} from '../../constants/factSheetSections';
import {PageRoutes} from '../../enums/enums';

export default function FactsheetStickyHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const {factsheetId} = useParams();

  const sectionOptions = factSheetSections.map((s) => ({
    ...s,
    label: CLocalizedTextString(s.dictKey),
  }));

  const sortDropdownOptions = sectionOptions.reduce<Record<string, string>>(
      (acc, option) => {
        acc[option.key] = option.label;
        return acc;
      },
      {}
  );

  const baseUrl = PageRoutes.PUBLIC_FACTSHEET_COLLECTION_OUTLET;

  const currentSectionKey = sectionOptions.find(opt => {
    if (opt.key === 'overview') {
      return location.pathname === `/${baseUrl}/${factsheetId}` || location.pathname === `/${baseUrl}/${factsheetId}/${opt.to}`;
    }
    return location.pathname === `/${baseUrl}/${factsheetId}/${opt.to}`;
  })?.key ?? 'overview';

  const handleNavigate = (selectedKey: string) => {
    const selectedOption = sectionOptions.find((opt) => opt.key === selectedKey);
    if (selectedOption) {
      navigate(`/${baseUrl}/${factsheetId}/${selectedOption.to}`);
    }
  };

  return (
      <div className="flex justify-end">
        <CSortDropdown
            labelDesc={CLocalizedTextString('fsNavigation')}
            options={sortDropdownOptions}
            defaultKey={currentSectionKey}
            onChange={handleNavigate}
        />
      </div>
  );
}
